/* MCC app cards fix for product recommendation cards. Moved from snippets/mcc-app-cards-fix.liquid so browsers can cache it (6 Oct 2026). */

(function() {
  'use strict';
  
  // Prevent double initialization
  if (window.MCCAppCardsInitialized) return;
  window.MCCAppCardsInitialized = true;
  
  console.log('MCC App Cards Fix: Initializing');
  
  // Helper to stop event propagation
  function stopEvent(e) {
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    return false;
  }
  
  // Update card display (tiers, messages)
  function updateCardDisplay(card) {
    var input = card.querySelector('.mcc-quantity__input');
    if (!input) return;
    
    var qty = parseInt(input.value) || 1;
    var bulkQty = parseInt(card.dataset.bulkQty) || 3;
    var basePrice = parseInt(card.dataset.basePrice) || 0;
    var bulkPrice = parseInt(card.dataset.bulkPrice) || basePrice;
    var bulkDiscount = parseInt(card.dataset.bulkDiscount) || 10;
    
    // Update tier highlighting
    var tierSingle = card.querySelector('.mcc-bulk-pricing__tier--single');
    var tierBulk = card.querySelector('.mcc-bulk-pricing__tier--bulk');
    
    if (tierSingle && tierBulk) {
      if (qty >= bulkQty) {
        tierSingle.classList.remove('is-active');
        tierBulk.classList.add('is-active');
      } else {
        tierSingle.classList.add('is-active');
        tierBulk.classList.remove('is-active');
      }
    }
    
    // Update savings message
    var message = card.querySelector('.mcc-quick-add__message');
    if (message) {
      if (qty >= bulkQty) {
        var savings = ((basePrice - bulkPrice) * qty) / 100;
        message.innerHTML = '<span class="mcc-quick-add__message-icon">✓</span> You\'re saving $' + savings.toFixed(2) + ' (' + bulkDiscount + '% off)';
        message.classList.remove('mcc-quick-add__message--upsell');
        message.classList.add('mcc-quick-add__message--savings');
        message.style.display = 'flex';
      } else {
        var needed = bulkQty - qty;
        message.innerHTML = '<span class="mcc-quick-add__message-icon">💡</span> Add ' + needed + ' more to save ' + bulkDiscount + '%!';
        message.classList.add('mcc-quick-add__message--upsell');
        message.classList.remove('mcc-quick-add__message--savings');
        message.style.display = 'flex';
      }
    }
  }
  
  // AJAX Add to Cart
  function handleAddToCart(form, button) {
    var card = button.closest('.mcc-card-enhanced');
    var quantity = 1;
    
    // Try multiple ways to get the quantity
    if (card) {
      var quantityInput = card.querySelector('.mcc-quantity__input');
      if (quantityInput) {
        var rawValue = quantityInput.value;
        quantity = parseInt(rawValue, 10);
        if (isNaN(quantity) || quantity < 1) quantity = 1;
        console.log('MCC App Cards: Found quantity input, raw value:', rawValue, 'parsed:', quantity);
      } else {
        console.log('MCC App Cards: No quantity input found in card');
      }
    } else {
      console.log('MCC App Cards: No card found');
    }
    
    var variantInput = form.querySelector('input[name="id"]');
    var variantId = variantInput ? variantInput.value : null;
    
    if (!variantId) {
      console.error('MCC App Cards: No variant ID found');
      return;
    }
    
    // Update button state - handle different button structures
    var buttonText = button.querySelector('.mcc-quick-add__text');
    var buttonLoading = button.querySelector('.mcc-quick-add__loading');
    var originalText = buttonText ? buttonText.textContent : button.textContent.trim();
    
    // Store original text on button for later
    button.dataset.originalText = originalText;
    
    if (buttonText) {
      buttonText.style.display = 'none';
    } else {
      // If no separate text span, update button directly
      button.dataset.originalHtml = button.innerHTML;
    }
    
    if (buttonLoading) {
      buttonLoading.style.display = 'flex';
    } else {
      // Show loading text if no loading spinner
      if (!buttonText) {
        button.innerHTML = '<span>Adding...</span>';
      }
    }
    
    button.disabled = true;
    
    console.log('MCC App Cards: Adding to cart - Variant:', variantId, 'Qty:', quantity);
    
    // Use form-encoded format (more reliable)
    var formData = 'id=' + encodeURIComponent(variantId) + '&quantity=' + encodeURIComponent(quantity);
    
    console.log('MCC App Cards: Request body:', formData);
    
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 
        'Content-Type': 'application/x-www-form-urlencoded',
        'Accept': 'application/json'
      },
      body: formData
    })
    .then(function(res) { return res.json(); })
    .then(function(data) {
      console.log('MCC App Cards: Added to cart successfully', data);
      console.log('MCC App Cards: Quantity added:', data.quantity);
      
      // Show success state
      if (buttonText) {
        buttonText.textContent = 'Added!';
        buttonText.style.display = '';
      } else {
        button.innerHTML = '<span class="mcc-quick-add__text">Added!</span>';
      }
      
      if (buttonLoading) buttonLoading.style.display = 'none';
      button.classList.add('is-added');
      button.disabled = false;
      
      // Update cart count
      return fetch('/cart.js');
    })
    .then(function(res) { return res.json(); })
    .then(function(cart) {
      console.log('MCC App Cards: Cart updated, items:', cart.item_count);
      
      // Update cart count elements
      document.querySelectorAll('.cart-count-bubble span[aria-hidden="true"]').forEach(function(el) {
        el.textContent = cart.item_count;
      });
      document.querySelectorAll('.cart-count').forEach(function(el) {
        el.textContent = cart.item_count;
      });
      document.querySelectorAll('[data-cart-count]').forEach(function(el) {
        el.textContent = cart.item_count;
      });
      
      var bubbles = document.querySelectorAll('.cart-count-bubble');
      bubbles.forEach(function(bubble) {
        if (cart.item_count > 0) {
          bubble.classList.remove('hidden');
          bubble.style.display = '';
        }
      });
      
      // Dispatch event
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
      
      // If already on the cart page, reload so totals/items update correctly
      if (window.location.pathname === '/cart') {
        setTimeout(function() {
          window.location.reload();
        }, 500);
        return;
      }
      
      // Reset button after delay (non-cart pages)
      setTimeout(function() {
        button.classList.remove('is-added');
        if (buttonText) {
          buttonText.textContent = button.dataset.originalText || 'Add to cart';
        } else if (button.dataset.originalHtml) {
          button.innerHTML = button.dataset.originalHtml;
        }
      }, 2000);
    })
    .catch(function(error) {
      console.error('MCC App Cards: Cart error', error);
      if (buttonText) {
        buttonText.textContent = 'Error - Retry';
        buttonText.style.display = '';
      } else {
        button.innerHTML = '<span>Error - Retry</span>';
      }
      if (buttonLoading) buttonLoading.style.display = 'none';
      button.disabled = false;
      
      setTimeout(function() {
        if (buttonText) {
          buttonText.textContent = button.dataset.originalText || 'Add to cart';
        } else if (button.dataset.originalHtml) {
          button.innerHTML = button.dataset.originalHtml;
        }
      }, 2000);
    });
  }
  
  // Check if card is inside a recommendations section (dynamically loaded)
  function isRecommendationCard(element) {
    return element.closest('.product-recommendations') || 
           element.closest('product-recommendations') ||
           element.closest('[data-product-recommendations]') ||
           element.closest('.related-products') ||
           element.closest('#product-recommendations');
  }
  
  // Main event handler using capture phase
  // ONLY handles cards inside product recommendations sections
  document.addEventListener('mousedown', function(e) {
    var target = e.target;
    var btn, card;
    
    // Handle minus button (only for recommendation cards)
    btn = target.closest('.mcc-quantity__btn--minus');
    if (btn && isRecommendationCard(btn)) {
      card = btn.closest('.mcc-card-enhanced');
      if (card) {
        stopEvent(e);
        var input = card.querySelector('.mcc-quantity__input');
        if (input) {
          var val = parseInt(input.value, 10) || 1;
          if (val > 1) {
            val = val - 1;
            input.value = val;
            input.setAttribute('value', val);
            console.log('MCC App Cards: Minus clicked, new value:', val);
            updateCardDisplay(card);
          }
        } else {
          console.log('MCC App Cards: Minus clicked but no input found');
        }
        return false;
      }
    }
    
    // Handle plus button (only for recommendation cards)
    btn = target.closest('.mcc-quantity__btn--plus');
    if (btn && isRecommendationCard(btn)) {
      card = btn.closest('.mcc-card-enhanced');
      if (card) {
        stopEvent(e);
        var input = card.querySelector('.mcc-quantity__input');
        if (input) {
          var val = parseInt(input.value, 10) || 1;
          if (val < 99) {
            val = val + 1;
            input.value = val;
            input.setAttribute('value', val);
            console.log('MCC App Cards: Plus clicked, new value:', val);
            updateCardDisplay(card);
          }
        } else {
          console.log('MCC App Cards: Plus clicked but no input found');
        }
        return false;
      }
    }
    
    // Handle Add to Cart button (only for recommendation cards)
    btn = target.closest('.mcc-quick-add__btn:not(.mcc-quick-add__btn--options):not(.mcc-quick-add__btn--sold-out)');
    if (btn && isRecommendationCard(btn)) {
      var form = btn.closest('.mcc-quick-add__form');
      if (form) {
        console.log('MCC App Cards: Add to cart clicked (recommendation card)');
        stopEvent(e);
        handleAddToCart(form, btn);
        return false;
      }
    }
  }, true);
  
  // Also catch click events (only for recommendation cards)
  document.addEventListener('click', function(e) {
    var target = e.target;
    
    // Only handle clicks inside recommendation sections
    if (!isRecommendationCard(target)) return;
    
    // Stop propagation for our interactive elements
    if (target.closest('.mcc-quantity__btn--minus') || 
        target.closest('.mcc-quantity__btn--plus') ||
        target.closest('.mcc-quick-add__btn:not(.mcc-quick-add__btn--options):not(.mcc-quick-add__btn--sold-out)')) {
      stopEvent(e);
      return false;
    }
    
    // Handle card click for navigation (only for non-interactive areas)
    var card = target.closest('.mcc-card-enhanced');
    if (card) {
      var isInteractive = target.closest('.mcc-quick-add') || 
                         target.closest('.mcc-card__action') || 
                         target.closest('.mcc-quantity') ||
                         target.closest('.mcc-bulk-pricing') ||
                         target.closest('button') ||
                         target.closest('input');
      
      if (!isInteractive) {
        var clickedLink = target.closest('a');
        if (clickedLink && clickedLink.href) {
          return; // Let link work naturally
        }
        
        var productUrl = card.dataset.productUrl;
        if (productUrl) {
          console.log('MCC App Cards: Card clicked, navigating');
          window.location.href = productUrl;
          return false;
        }
      }
    }
  }, true);
  
  // Prevent form submission for recommendation cards (force AJAX)
  document.addEventListener('submit', function(e) {
    if (e.target.classList && e.target.classList.contains('mcc-quick-add__form')) {
      if (isRecommendationCard(e.target)) {
        console.log('MCC App Cards: Preventing form submit');
        stopEvent(e);
        return false;
      }
    }
  }, true);
  
  console.log('MCC App Cards Fix: Ready');
})();
